// get products
import axios from "axios";

export function getHeaders() {
  const Authorization = `Bearer ${localStorage.getItem('access_token')}`;
  return { Authorization };
}

const getApi = () => {
  const api = axios.create({
      baseURL: `${window.location.origin}`,
      timeout: 30000,
      headers: getHeaders(),
  });

   api.interceptors.response.use(
       (response) => response,
       (error) => {
           if (error && error.response && (error.response.status === 500 || error.response.status === 401)) {
               localStorage.removeItem('access_token');
           }
           return error;
       },
   );
  return api;
};

export const productApi = {
  getProductBySlug: (slug) => getApi().get(`${window.location.origin}/api/promo/store/products/${slug}`,),

  getProductsList: (skip, take, filters = [], include, sort, includeFilters = true, ) => getApi().get(`${window.location.origin}/api/promo/store/products-store?includeFilters=${includeFilters}&skip=${encodeURIComponent(JSON.stringify(
    skip || 0
  ))}&take=${encodeURIComponent(JSON.stringify(
    take,
  ))}&filters=${encodeURIComponent(JSON.stringify(
    filters,
  ))}&include=${encodeURIComponent(JSON.stringify(
    include,
  ))}&sort=${encodeURIComponent(JSON.stringify(
    sort,
  ))}`),

  getSuggestions: (query, options) => getApi().get(`${window.location.origin}/api/products/suggestions?o=${JSON.stringify({ options })}&q=${query}`),

  getFilters: (filters = [], includeFilters = true) => getApi().get(`${window.location.origin}/api/promo/store/products/filters?includeFilters=${includeFilters}&filters=${encodeURIComponent(JSON.stringify(
    filters
  ))}`),
};

export const couponApi = {
  getCoupon: (couponCode) => getApi().get(`/api/promo/ecommerce/coupon/check/${couponCode}`,),
};


export const getProducts = (type) => {
  let newProducts = []
  productApi.getProductsList(0, 8, [], ["productData.productName", "productData.productBrand", "productData.primaryImageUrl", "productData.colors", "productData.description","productData.minimumPartPrice"], []).then(response => {
    newProducts = response.data.items
  }
  )
  return newProducts
};

// get product discount price
export const getDiscountPrice = (price, discount) => {
  return discount && discount > 0 ? price - price * (discount / 100) : null;
};

// get product cart quantity
export const getProductCartQuantity = (cartItems, product, color, size) => {
  let productInCart = cartItems.filter(
    single =>
      single.id === product.id &&
      (single.selectedProductColor
        ? single.selectedProductColor === color
        : true) &&
      (single.selectedProductSize ? single.selectedProductSize === size : true)
  )[0];
  if (cartItems.length >= 1 && productInCart) {
    if (product.variation) {
      return cartItems.filter(
        single =>
          single.id === product.id &&
          single.selectedProductColor === color &&
          single.selectedProductSize === size
      )[0].quantity;
    } else {
      return cartItems.filter(single => product.id === single.id)[0].quantity;
    }
  } else {
    return 0;
  }
};

export const checkboxFilter = (products, sortType, categoriesToFilterBy) => {
  let filterSet = new Set([categoriesToFilterBy]);
  if (products && sortType && categoriesToFilterBy) {
  let filteredProducts = products.filter(product => 
     product.category.some(category => filterSet.has(category))
  );
  return filteredProducts
  }
  return products
}

let filters= {
  category: [],
  brands: [],
  colors: []
}

export const getFilters = (category, brands, colors, range) => {
    filters = {
      category: category,
      brands: brands,
      colors: colors,
      priceRange: {
        min: range?.range?.min,
        max: range?.range?.max
      }
    }
}


const getPriceRange= (products) => {
//  if (filters.priceRange.max) {
//    return products.price <= filters.priceRange.max && products.price >= 0
//  }
//  if (filters.priceRange.min) {
//    return products.price <= 5000 && products.price >= filters.priceRange.min
//  }
  if (filters.priceRange.min && filters.priceRange.max) {
    return products.price <= filters.priceRange.max && products.price >= filters.priceRange.min
  }
  return products
}

const getCategories = (products) => {
  if (filters?.category?.length > 0) {
  let filterSet = new Set(filters.category);
    return products.category.some(category => filterSet.has(category))
  }
  return products
}

const getBrands = (products) => {
  if (filters?.brands?.length > 0) {
    const filteredBrands = new Set(filters.brands)
    return filteredBrands.has(products.brand); 
  }
  return products
}

const getColor = (products) => {
  if (filters?.colors?.length > 0) {
    const filteredColor = new Set(filters.colors)
    return products.variation && products.variation.some(val => filteredColor.has(val.color)); 
  }
  return products
}

export const getFilteredProducts = (products) => {
//  let getFilteredProducts = products.filter(getCategories).filter(getBrands).filter(getColor).filter(getPriceRange)
//  return getFilteredProducts
}


//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "category") {
      let filterSet = new Set([sortValue]);
      let filteredProducts = products.filter(product => 
        product.category.some(category => filterSet.has(category))
     );
     return filteredProducts
    }
    if (sortType === "brand") {
      if (sortValue.length < 1) {
        return products
      }
      const filteredColor = new Set(sortValue)
      return products.filter(val => filteredColor.has(val.brand));
      };
    if (sortType === "color") {
      if (sortValue.length < 1) {
        return products
      }
      const filteredColor = new Set(sortValue)
      return products.filter(
        product => product.variation && product.variation.some(val => filteredColor.has(val.color)));
      };
    //  return products.filter(
    //    product =>
    //      product.variation &&
    //      product.variation.filter(single => single.color === sortValue)[0]
    //  );
    
    if (sortType === "size") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(
            single => single.size.filter(single => single.name === sortValue)[0]
          )[0]
      );
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts;
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          return b.price - a.price;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          return a.price - b.price;
        });
      }
      if (sortValue === "nameAtoZ") {
        return sortProducts.sort((a, b) => a.name.normalize().localeCompare(b.name.normalize()));
      }
      if (sortValue === "nameZtoA") {
        return sortProducts.sort((a, b) => b.name.normalize().localeCompare(a.name.normalize()));
      }
    }
  }
  return products;
};

// get individual element
const getIndividualItemArray = array => {
  let individualItemArray = array.filter(function(v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = products => {
  let productCategories = [];
  products &&
    products.map(product => {
      return (
        product.category &&
        product.category.map(single => {
          return productCategories.push(single);
        })
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories;
};

// get individual tags
export const getIndividualTags = products => {
  let productTags = [];
  products &&
    products.map(product => {
      return (
        product.tag &&
        product.tag.map(single => {
          return productTags.push(single);
        })
      );
    });
  const individualProductTags = getIndividualItemArray(productTags);
  return individualProductTags;
};

export const getIndividualBrand = products => {
  let productCategories = [];
  products &&
    products.map(product => {
      return (
        productCategories.push(product.brand)
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories;
};

// get individual colors
export const getIndividualColors = products => {
  let productColors = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return productColors.push(single.color);
        })
      );
    });
  const individualProductColors = getIndividualItemArray(productColors);
  return individualProductColors;
};

// get individual sizes
export const getProductsIndividualSizes = products => {
  let productSizes = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return single.size.map(single => {
            return productSizes.push(single.name);
          });
        })
      );
    });
  const individualProductSizes = getIndividualItemArray(productSizes);
  return individualProductSizes;
};

// get product individual sizes
export const getIndividualSizes = product => {
  let productSizes = [];
  product.variation &&
    product.variation.map(singleVariation => {
      return (
        singleVariation.size &&
        singleVariation.size.map(singleSize => {
          return productSizes.push(singleSize.name);
        })
      );
    });
  const individualSizes = getIndividualItemArray(productSizes);
  return individualSizes;
};

export const setActiveSort = e => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const setActiveLayout = e => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};

export const toggleShopTopFilter2 = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper2"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      'auto';
  }
  e.currentTarget.classList.toggle("active");
};

export const toggleShopTopFilter3 = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper3"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      'auto';
  }
  e.currentTarget.classList.toggle("active");
};

export const toggleShopTopFilter4 = (e, query, icon) => {
  const shopTopFilterWrapper = document.querySelector(
    `#${query}`
  );
  const iconWrapper = document.querySelector(
    `#${icon}`
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      'auto';
  }
  if (iconWrapper.classList.value === "fa fa-angle-right") {
    iconWrapper.classList.value = 'fa fa-angle-down';
  } else {
    iconWrapper.classList.value =
    "fa fa-angle-right";
  }
  
  e.currentTarget.classList.toggle("active");
};